import { ApiService } from '../apiService'
import type {
  AdminSubscriptionPlanDto,
  BusinessSubscriptionPlanDto,
  SaveBusinessSubscriptionPlanRequest,
  SaveSubscriptionPlanRequest,
} from '../types/plans'

/**
 * Subscription plan management. Plans are read uncached by the app on every entitlement check, so a
 * saved change is live for everyone on the plan as soon as the request returns.
 *
 * Rule violations (a second free plan, renaming, deleting a plan in use) come back as a 400 whose
 * `message` is written to be shown as it is.
 */
export const plansApi = {
  consumer: {
    list: () => ApiService.get<AdminSubscriptionPlanDto[]>('/admin/subscription-plans'),

    create: (request: SaveSubscriptionPlanRequest) =>
      ApiService.post<AdminSubscriptionPlanDto>('/admin/subscription-plans', request),

    update: (id: string, request: SaveSubscriptionPlanRequest) =>
      ApiService.put<AdminSubscriptionPlanDto>(`/admin/subscription-plans/${id}`, request),

    remove: (id: string) => ApiService.delete<void>(`/admin/subscription-plans/${id}`),
  },

  business: {
    list: () =>
      ApiService.get<BusinessSubscriptionPlanDto[]>('/admin/business-subscription-plans', { includeInactive: true }),

    create: (request: SaveBusinessSubscriptionPlanRequest) =>
      ApiService.post<BusinessSubscriptionPlanDto>('/admin/business-subscription-plans', request),

    update: (id: string, request: SaveBusinessSubscriptionPlanRequest) =>
      ApiService.put<BusinessSubscriptionPlanDto>(`/admin/business-subscription-plans/${id}`, request),

    remove: (id: string) => ApiService.delete<void>(`/admin/business-subscription-plans/${id}`),
  },
}
